export class TirednessIndicator {
  tlc: string;
  noteGlobal: number;

  constructor(tlc: string, noteGlobal: number) {
    this.tlc = tlc;
    this.noteGlobal = noteGlobal;
  }
}
